<form class="metadata-filters-widget" tabindex="1" #metadataFiltersForm="ngForm" autocomplete="off"
    [class.disabled]="isDisabled">
    <div *ngFor="let row of rows; index as i, last as l, first as f; trackBy: trackByFn" class="metadata-row"
        [ngClass]="{'row-margin-bottom': !l}">
        <div class="custom-combo-box">
            <li class="dropdown custom-dropdown" dropdown dropup="true" [attr.data-automation-id]="automationId"
                [isDisabled]="isInFreeFormMode">
                <div dropdownToggle class="dropdown-container"
                    [popoverAutomationId]="automationId + '-filter-input-error-message'"
                    [(resScrollablePopover)]="row.notValid" [isSingleLine]="true"
                    [popoverErrorMessage]="row.errorMessage" popoverType="error" popoverPlacement="right">
                    <input type="text" autocomplete="off" [(ngModel)]="row.selectedValue" [disabled]="isInFreeFormMode"
                        (ngModelChange)="filterData(row, i, l)" (click)="onClick($event, row, i, l)"
                        placeholder="Type to filter ..." [attr.data-automation-id]="automationId + '-filter-input'"
                        name="drop_{{i}}" formErrorInput [hasInputError]="row.hasError"
                        (focusout)="validateOnBlur(row, i, l)" />
                    <button [attr.data-automation-id]="automationId + '-toggle-button'" [disabled]="isInFreeFormMode"
                        (click)="getAllItems($event, row)" (focusout)="tabOut($event, 'listAllButton', row)">
                        <i class="fa fa-caret-down color-grey-10"></i>
                    </button>
                </div>
                <ul *dropdownMenu class="dropdown-menu" id="{{automationId + i}}"
                    [attr.data-automation-id]="automationId + '-dropdown-menu'">
                    <li *ngFor="let item of row.metadataProperties; index as i"
                        [ngClass]="[item?.name.toLowerCase() === row.selectedValue?.toLowerCase() ? 'selected-option' : '']"
                        (mousedown)="onDropdownChange(i, row, l, item)" title="{{item.description}}"
                        class="custom-dropdown-option" [attr.data-automation-id]="automationId + '-option-' + i">
                        <span>{{item.name}}</span>
                    </li>
                </ul>
            </li>
        </div>

        <button *ngIf="row.hasIcon" [attr.data-automation-id]="automationId + '-icon-button'" (click)="openPicker(row)"
            [disabled]="isInFreeFormMode" class="input-icon-button">
            <i class="fa fa-pencil-square-o color-blue-01"></i>
        </button>
        <input type="text" [(ngModel)]="row.query" [disabled]="!row.selectedValue || isInFreeFormMode"
            [attr.data-automation-id]="automationId + '-query-input'" #queryInput+{{}}
            [ngStyle]="{'margin-left' : row.hasIcon ? '0px' : '10px'}" [hidden]="row.selectedType !== 'input'"
            name="query_{{i}}" class="field-query-width" spellcheck="false" (ngModelChange)="onModelChange(row)">
        <button class="remove-row clear-text-input-button text-clear-button"
            [disabled]="!row.selectedValue || isInFreeFormMode" [hidden]="row?.query?.length === 0"
            (click)="row.query = '';onModelChange(row)"
            [attr.data-automation-id]="automationId + '-query-input-clear-button'">
            <i class="fa fa-times"></i>
        </button>
        <button type="button" class="remove-row transparent-button" [disabled]="l || isDisabled || isInFreeFormMode"
            [hidden]="isDisabled" (click)="onRemoveRow(i, row, last)"
            [attr.data-automation-id]="automationId + '-' + i + '-delete-button'"
            [tabindex]="excludeTrashBtnFromTabIndex ? -1 : 0">
            <i class="fa fa-trash-o"></i>
        </button>

        <div class="range-input" class="range-container"
            [ngStyle]="{'display' : row.selectedType === 'range' ? 'flex' : 'none'}">
            <input type="text" class="min-max-input" name="queryMin_{{i}}" placeholder="Min ..."
                [(ngModel)]="row.minResult" #queryInput+{{}}
                onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                [attr.data-automation-id]="automationId + '-min-input'" (ngModelChange)="onModelChange(row)"
                [disabled]="isInFreeFormMode">
            <div *ngIf="row.minResult || row.minResult === 0">
                <button [attr.data-automation-id]="automationId + '-min-delete-button'"
                    (click)="row.minResult = '';onModelChange(row)" class="text-clear-button"
                    [disabled]="isInFreeFormMode">
                    <i class="fa fa-times"></i>
                </button>
            </div>
            <div class="pickers-separator">~~</div>
            <input type="text" class="min-max-input" name="queryMax_{{i}}" [(ngModel)]="row.maxResult"
                onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                placeholder="Max ..." [attr.data-automation-id]="automationId + '-max-input'"
                (ngModelChange)="onModelChange(row)" [disabled]="isInFreeFormMode">
            <div *ngIf="row.maxResult || row.maxResult === 0">
                <button [attr.data-automation-id]="automationId + '-max-delete-button'"
                    (click)="row.maxResult = '';onModelChange(row)" class="text-clear-button"
                    [disabled]="isInFreeFormMode">
                    <i class="fa fa-times"></i>
                </button>
            </div>
        </div>
        <div class="date-pickers" class="date-container"
            [ngStyle]="{'display' : row.selectedType === 'date' ? 'flex' : 'none'}">
            <res-custom-date-time-picker class="date-time-picker" name="queryStart_{{i}}" ngDefaultControl
                [inputPlaceholder]="defaultDatePlaceholders[0]" [(ngModel)]="row.startDate" [isDateRange]="true"
                [hasErrorMessage]="dateError" [isStart]="true" [isEnd]="false" (ngModelChange)="onModelChange(row)"
                [disabled]="isInFreeFormMode" [automationId]="automationId + '-start-date'">
            </res-custom-date-time-picker>
            <div class="date-picker-separator">~~</div>
            <res-custom-date-time-picker class="date-time-picker" name="queryEnd_{{i}}" ngDefaultControl
                [inputPlaceholder]="defaultDatePlaceholders[1]" [(ngModel)]="row.endDate" [isDateRange]="true"
                [hasErrorMessage]="dateError" [isStart]="false" [isEnd]="true" (ngModelChange)="onModelChange(row)"
                [disabled]="isInFreeFormMode" [automationId]="automationId + '-end-date'">
            </res-custom-date-time-picker>
        </div>
    </div>
</form>